import router from 'next/router';
import { toastNotifyError } from 'src/components/Common/Toast';
import { useSSRSelector } from 'src/redux';
import { RootState } from 'src/redux/reducers';
import { getRoute, PATH } from 'src/utils/routes';

export function useBlogUtils() {
  const domain = useSSRSelector((state: RootState) => state.storeReducer?.store?.domain);

  function gotToBlog(blogUrl) {
    if (!blogUrl) {
      toastNotifyError('Invalid blog url !');
      return;
    }

    router.push(getRoute(`${PATH.BLOG}/${blogUrl}`, domain));
  }

  return {
    gotToBlog,
  };
}
